import React from "react"
import Paper from "@material-ui/core/Paper"
import { makeStyles, Typography } from "@material-ui/core"
import { split, last, toUpper } from "ramda"
const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
  },
  span: {
    marginLeft: theme.spacing(0.5),
  },
}))
const type = x => x.origen.publicURL |> split(".") |> last |> toUpper
const Docs = ({ documentos }) => {
  const classes = useStyles()
  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography color="primary" component="span">
        DOCUMENTACIÓN:
      </Typography>
      {documentos.filter(doc => doc && doc.origen).map((doc, index, docs) => (
        <span key={index} className={classes.span}>
          <span>
            <a href={doc.origen.publicURL} target="_blank" rel="noreferrer">{`${
              doc.nombre
            } (${type(doc)})`}</a>
          </span>
          <span>{index < docs.length - 1 ? " | " : ""}</span>
        </span>
      ))}
    </Paper>
  )
}
export default Docs
